import { BadgeStatus } from '@cas/components/data-display/badge-dot/BadgeDot';
import StatusCell from '@cas/components/data-display/status-cell/StatusCell';
import { EmptyCell } from '../../formatters/genericFormatters';
import { AssetDeviceType, RegisteredAssetModel } from '@casops/store/apis/registeredAssetsApi';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

interface SoftwareStatusCellRendererProps {
  value?: boolean;
  data: RegisteredAssetModel;
}

export default function SoftwareStatusCellRenderer({
  value,
  data,
}: SoftwareStatusCellRendererProps): ReactElement | string {
  const { t } = useTranslation();

  if (typeof value !== 'boolean' || !data || data.hw === AssetDeviceType.PPU) {
    return EmptyCell;
  }

  const label = value ? t('UpToDate') : t('OutOfDate');
  const status = value ? BadgeStatus.Healthy : BadgeStatus.Danger;

  return <StatusCell label={label} status={status} />;
}
